import { FC, useEffect, useState } from 'react';
import { Editor } from '@tiptap/react';
import { Avatar, Button } from 'antd';
import { AggregationColor } from 'antd/es/color-picker/color';
import { TbSquareRoundedFilled } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { SmallTooltip } from '@/shared';
import { PlatformColorPicker } from '@/shared/components/forms';

interface TextColorDropdownProps {
    editor: Editor;
}

const TextColorDropdown: FC<TextColorDropdownProps> = ({ editor }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <SmallTooltip title='Text Color...' placement='topLeft'>
                <PlatformColorPicker
                    placement='leftTop'
                    styles={{ popup: { marginRight: '1.5rem' } }}
                    size='small'
                    className={editor.isActive('bold') ? 'is-active' : ''}
                    onChange={(value: AggregationColor, css) => {
                        editor.commands.setColor(value.toHexString());
                    }}
                    value={editor.getAttributes('textStyle').color}
                >
                    <Button
                        className={editor.isActive('bold') ? 'is-active' : ''}
                        icon={
                            <Avatar
                                size={16}
                                icon={
                                    <TbSquareRoundedFilled
                                        style={{
                                            color: editor.getAttributes('textStyle').color
                                                ? editor.getAttributes('textStyle').color
                                                : token.colorText,
                                        }}
                                    />
                                }
                                shape='square'
                                style={{
                                    border: `1px solid ${token.colorBorder}`,
                                }}
                            />
                        }
                        type='text'
                    />
                </PlatformColorPicker>
            </SmallTooltip>
        </>
    );
};

export default TextColorDropdown;
